module.exports = __webpack_public_path__ + "img/icon-startup-light-gray.68607a9a.svg";